<template>
    <div class="t_select">
        <van-popup v-model="showMapPopup" position="right"  :style="{ width: '100%', height: '70%' }">
            <van-field v-model="searchAddress" label="搜索地址" placeholder="请输入地址或拖动标记点获取位置" @input="onSearchAddress"
                class="search-results" v-if="isSearch"/>
            <van-cell-group v-if="showseach">
                <van-cell v-for="(result, index) in searchResults" :key="index" :title="result.name"
                    @click="selectAddress(result)" />
            </van-cell-group>
            <div id="mapContainer" class="map-container" :style="{ height: dynamicHeight }"></div>
            <span style="font-size: 12px; color: red;">当前位置:{{ selectedAddress.address }}</span>
      <div class="button-container" v-if="isbutton || isNavigation">
        <van-button type="info" block @click="relocate" v-if="isbutton">重新获取定位</van-button>
        <van-button type="primary" block @click="confirmSelection" v-if="isbutton">确定</van-button>
        <van-button  type="info" @click="startNavigation" v-if="isNavigation">导航</van-button>
      </div>
        </van-popup>
    </div>
</template>

<script type="text/javascript" src="https://webapi.amap.com/maps?v=2.0">
</script>
<script>
  import { Toast, Dialog } from 'vant';
  import AMapLoader from '@amap/amap-jsapi-loader';
  
  export default {
    name: 'AddressPicker',
    props: {
      value: {
        type: Boolean,
        default: false
      },
    draggable: {
      type: Boolean,
      default: false
    },
      columns:  {
      type: Object,
      required: true
    },
      // 是否显示搜索框
      isSearch: {
        type: Boolean,
        default: false
      },
      // 是否显示定位按钮
      isbutton: {
        type: Boolean,
        default: false
      },
      // 是否显示导航按钮
      isNavigation: {
        type: Boolean,
        default: false
      },
    },
    computed: {
        dynamicHeight() {
            return this.isbutton || this.isNavigation ? 'calc(100% - 170px)' : 'calc(100% - 60px)';
        }
    },
    data() {
      return {
        showMapPopup: this.value,
        searchAddress: '',
        searchResults: [],
        showseach: false,
        map: null,
        marker: null,
        locationLoading: false,
        selectedAddress: {
          address: '',
          latitude: 0,
          longitude: 0
        }
      };
    },
    watch: {
      value(newVal) {
        this.showMapPopup = newVal;
      },
      showMapPopup(newVal) {
        this.$emit('input', newVal);
        if (newVal) {
          this.getmapLoader();
        }
      }
    },
    methods: {
      getmapLoader() {
        this.locationLoading = true;
        //获取父页面传过来的地理位置
        const mapdata = this.columns
        AMapLoader.load({
          key: "8f1b504a4b00e681244a5b517e34d238",
          version: "2.0",
          plugins: [
            "AMap.Geocoder",
            "AMap.Marker",
            "AMap.ToolBar",
            "AMap.Scale",
            "AMap.ElasticMarker",
            "AMap.Geolocation",
            "AMap.AutoComplete"
          ]
        }).then((AMap) => {
            if(mapdata && mapdata.latitude && mapdata.longitude){
            // 如果 mapdata 不为空，直接使用 mapdata 中的值初始化地图
            this.selectedAddress.latitude = mapdata.latitude;
            this.selectedAddress.longitude = mapdata.longitude;
            this.initMap(this.selectedAddress.longitude, this.selectedAddress.latitude);
            this.locationLoading = false;
            }else{
                this.getLocation();
        }
        }).catch((e) => {
          console.log(e);
        });
      },
      getLocation(){
          this.$toast.loading("正在获取位置...");
          this.searchAddress = '';
          const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
          convert: true,
          showButton: true,
          buttonPosition: 'RB',
          buttonOffset: new AMap.Pixel(10, 20),
          zoomToAccuracy: true,
      });
        geolocation.getCurrentPosition((status, result) => {
        if (status === 'complete') {
          this.$toast.success("获取成功");
          this.selectedAddress.latitude = result.position.lat;
          this.selectedAddress.longitude = result.position.lng;
          this.initMap(this.selectedAddress.longitude, this.selectedAddress.latitude);
          let highAccuracy = result.accuracy <= 100; 
          setTimeout(() => {
              if (!highAccuracy) {
                  this.$toast.fail(`当前定位精度为 ${result.accuracy} 米,建议重新获取定位!`);
              } else {
                  this.$toast.fail(`当前定位精度为 ${result.accuracy} 米`);
              }
          }, 1000); 
        } else {
          // console.error('定位失败', result);
          this.$toast.fail('定位失败，请稍后重试');
        }
        this.locationLoading = false;
      });
      },
      initMap(longitude, latitude) {
        this.map = new AMap.Map('mapContainer', {
          zoom: 16,
          center: [longitude, latitude]
        });
  
        this.marker = new AMap.Marker({
          position: new AMap.LngLat(longitude, latitude),
          title: '当前位置'
        });
  
        this.map.add(this.marker);
        this.marker.on('dragend', (e) => {
          this.selectedAddress.latitude = e.lnglat.getLat();
          this.selectedAddress.longitude = e.lnglat.getLng();
          this.getAddressFromLatLng(this.selectedAddress.longitude, this.selectedAddress.latitude);
        });
        this.getAddressFromLatLng(this.selectedAddress.longitude, this.selectedAddress.latitude);
        // 设置marker可拖动
        this.marker.setDraggable(this.draggable);
      },
      onSearchAddress() {
        const keyword = this.searchAddress;
        if (keyword) {
          this.showseach = true;
          AMap.plugin("AMap.AutoComplete", () => {
            const autoOptions = {
              city: "全国",
              datatype: "all",
            };
            const autoComplete = new AMap.AutoComplete(autoOptions);
            autoComplete.search(keyword, (status, result) => {
              if (status === 'complete' && result.info === 'OK') {
              // 过滤掉 location 为空的结果
              this.searchResults = result.tips.filter(tip => tip.location);
              } else {
                this.searchResults = [];
                this.showseach = false;
              }
            });
          });
        }
      },
      selectAddress(result) {
        console.log(result);
        this.selectedAddress.address = result.name;
        this.selectedAddress.latitude = result.location.lat;
        this.selectedAddress.longitude = result.location.lng;
        this.searchAddress = result.name;
        this.showseach = false;
        this.initMap(this.selectedAddress.longitude, this.selectedAddress.latitude);
        this.emitSelectedAddress();
      },
      getAddressFromLatLng(lng, lat) {
        this.geocoder = new AMap.Geocoder({
          city: "全国",
          radius: 50,
          extensions: "all",
        });
        this.geocoder.getAddress([lng, lat], (status, result) => {
          if (status === "complete" && result.info === "OK") {
            if (result && result.regeocode) {
              this.selectedAddress.address = result.regeocode.formattedAddress;
              this.emitSelectedAddress();
            } else {
              Toast.fail('逆地理编码失败，请稍后重试');
            }
          }
        });
      },
      emitSelectedAddress() {
        this.$emit('address-selected', this.selectedAddress);
      },
    confirmSelection() {
        this.emitSelectedAddress();
        this.showMapPopup = false;
    },
    relocate() {
        this.getLocation();
         },
        startNavigation() {
            if (!this.selectedAddress.latitude || !this.selectedAddress.longitude) {
                return Toast.fail("位置信息不完整");
            }

            // 使用高德地图导航
            const url = `https://uri.amap.com/marker?position=${this.selectedAddress.longitude},${this.selectedAddress.latitude}&name=目的位置&src=mypage&coordinate=gaode&callnative=0`;
            window.location.href = url;
        }
      }
    };
  </script>

<style scoped>
.search-results {
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    z-index: 10;
    border-bottom: 1px solid #ebedf0;
}
.popup-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.map-container {
    flex: 1;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px; 
    /* 确保地图在搜索结果下方 */
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px; 
}

.button-container .van-button {
  flex: 1;
  margin-right: 5px;
}

.button-container .van-button:last-child {
  margin-right: 0;
}
.t_select {
    .van-popup {
        border-radius: 5px 5px 5px 5px;
    }
}
</style>